import {TweenMax} from 'gsap';
import CoreMessageDispatcher from '../../core/controller/CoreMessageDispatcher';
import SoundEvents from '../../core/events/SoundEvents';
import AudioChannel from '../../../../viscomjs/audio/AudioChannel';

const _channelStateMap = {
    background: './resources/audio/back011',
    menu: '',
    'event-cover-in': './resources/audio/zoomin',
    'event-cover-out': './resources/audio/zoomout',
    'event-0': './resources/audio/01',
    'event-1': './resources/audio/02',
    'event-2': './resources/audio/03',
    'event-3': './resources/audio/04',
    'event-4': './resources/audio/05',
    'event-5': './resources/audio/06',
    'event-6': './resources/audio/07',
    'event-7': './resources/audio/08',
    'event-8': './resources/audio/09',
    'event-9': './resources/audio/10',
    'event-10': './resources/audio/11',
    'event-11': './resources/audio/12'
};

const _dispatcher = CoreMessageDispatcher.instance();

const _init = mdr => {
    if (mdr.initiated) return mdr;

    for (const key in _channelStateMap) {
        if (!_channelStateMap.hasOwnProperty(key)) continue;

        if (_channelStateMap[key] && _channelStateMap[key].length > 0) {
            const curLoop = key === 'background';
            const channel = new AudioChannel(key, {
                loop: curLoop,
                defaultMuted: mdr.params.muted,
                src: [
                    {
                        src: `${_channelStateMap[key]}.ogg`,
                        type: 'audio/ogg'
                    },
                    {
                        src: `${_channelStateMap[key]}.mp3`,
                        type: 'audio/mpeg'
                    }
                ]
            });

            channel.addListener('complete', mdr.onComplete);

            mdr.channels[key] = channel;
        }
    }

    mdr.initiated = true;

    return mdr;
};

const _start = mdr => {
    if (mdr.started) return mdr;

    mdr._update(true);
    _addCoreListeners(mdr, true);

    mdr.started = true;

    if (mdr.model.soundOn) {
        mdr.firstStart = false;
        mdr.channels.background.volume = mdr.params.bgMaxVolume;
        mdr.channels.background.start();
    } else {
        mdr._off();
    }

    return mdr;
};

const _stop = mdr => {
    if (!mdr.started) return mdr;

    _addCoreListeners(mdr, false);

    mdr.started = false;
    return mdr;
};

const _on = (mdr, force) => {
    if (!mdr.started && !force) return mdr;
    if (mdr.state.isOn) return mdr;

    mdr.state.isOn = true;

    if (mdr.firstStart) {
        mdr.firstStart = false;
        mdr.channels.background.volume = mdr.params.bgMaxVolume;
        mdr.channels.background.start();
    }

    // View:
    // TODO: switch on
    for (const key in mdr.channels) {
        if (!mdr.channels.hasOwnProperty(key)) continue;
        mdr.channels[key].unmute();
    }

    return mdr;
};

const _off = (mdr, force) => {
    if (!mdr.started && !force) return mdr;
    if (!mdr.state.isOn) return mdr;

    mdr.state.isOn = false;

    // View:
    // TODO: switch off
    for (const key in mdr.channels) {
        if (!mdr.channels.hasOwnProperty(key)) continue;
        mdr.channels[key].mute();
    }

    return mdr;
};

const _update = (mdr, force) => {
    if (!mdr.started && !force) return mdr;

    const channelChanged = mdr.state.state !== mdr.model.soundChannelState;
    mdr.state.state = mdr.model.soundChannelState;

    if (!channelChanged) return mdr;

    // Audio hasn't been allowed yet
    if (mdr.firstStart) return mdr;

    // View:

    // TODO: play channel by _channelStateMap
    // mdr.channels[mdr.state.state].start();
    // console.log(mdr.channels[mdr.state.state], mdr.state.state);
    if (mdr.channels[mdr.state.state]) {
        // console.log(mdr.channels[mdr.state.state]);
        mdr.channels[mdr.state.state].start();
        mdr.soundsStarted++;

        if (mdr.soundsStarted > 0 && mdr.channels.background) {
            _channelChangeVolume(mdr.channels.background, mdr.params.bgMinVolume, mdr.params.bgVolumeChangeDuration);
        }
    }

    return mdr;
};

const _channelChangeVolume = (channel, volume, duration = 0.15) => {
    TweenMax.to(channel, duration, {
        volume: volume
    });
};

const _onComplete = (mdr /* , channel*/) => {
    mdr.soundsStarted--;

    if (mdr.soundsStarted < 1 && mdr.channels.background) {
        _channelChangeVolume(mdr.channels.background, mdr.params.bgMaxVolume, mdr.params.bgVolumeChangeDuration);
    }
};

//

//
// From Core
//
const _addCoreListeners = (mdr, b) => {
    if (b) {
        _dispatcher.on(SoundEvents.ON, mdr._on);
        _dispatcher.on(SoundEvents.OFF, mdr._off);
        _dispatcher.on(SoundEvents.CHANNEL_STATE_CHANGED, mdr._update);
        return;
    }

    _dispatcher.off(SoundEvents.ON, mdr._on);
    _dispatcher.off(SoundEvents.OFF, mdr._off);
    _dispatcher.off(SoundEvents.CHANNEL_STATE_CHANGED, mdr._update);
};

//

//
// Constructor
//
const SoundChannelsMediator = model => {
    const defaults = {
        bgMaxVolume: 0.8,
        bgMinVolume: 0.05,
        bgVolumeChangeDuration: 0.5
    };
    const mdr = {
        model: model,
        state: {
            isOn: true,
            state: ''
        },
        params: defaults,
        firstStart: true,
        started: false,
        soundsStarted: 0,
        channels: {}
    };

    mdr.init = () => {
        return _init(mdr);
    };

    mdr.start = () => {
        return _start(mdr);
    };

    mdr._on = force => {
        return _on(mdr, force);
    };

    mdr._off = force => {
        return _off(mdr, force);
    };

    mdr._update = force => {
        return _update(mdr, force);
    };

    mdr.stop = () => {
        return _stop(mdr);
    };

    mdr.onComplete = channel => {
        return _onComplete(mdr, channel);
    };

    mdr.init();

    return mdr;
};

export {SoundChannelsMediator};
export default SoundChannelsMediator;
